import Home from './routes/Home.svelte';
import About from './routes/About.svelte';
import Featured from './routes/Featured.svelte';
import Contact from './routes/Contact.svelte';
import ThanksContact from './routes/ThanksContact.svelte';
import ProjectSubmit from './routes/ProjectSubmit.svelte';
import NotFound from './routes/NotFound.svelte';

export default {
    '/': Home,
    '/about': About,
    '/featured': Featured,
    '/contact': Contact,
    '/contact/thanks': ThanksContact,
    '/project/create': ProjectSubmit,
    // The catch-all route must always be last
    '/404': NotFound,
    '*': NotFound
};
